function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148142",
  d: "M7.016,9.9a2.6,2.6,0,1,0-2.6-2.591A2.614,2.614,0,0,0,7.016,9.9ZM6.7,8.7a.379.379,0,0,1-.312-.171l-.659-.789a.346.346,0,0,1-.088-.247.321.321,0,0,1,.595-.171l.453.565L7.74,6.2a.344.344,0,0,1,.294-.177.315.315,0,0,1,.324.3.418.418,0,0,1-.077.247L7.027,8.523A.369.369,0,0,1,6.7,8.7Zm4.769-.871H17.4a.518.518,0,1,0,0-1.036H11.473a.518.518,0,0,0,0,1.036ZM7.016,16.707a2.6,2.6,0,1,0-2.6-2.6A2.615,2.615,0,0,0,7.016,16.707Zm0-1a1.6,1.6,0,1,1,1.6-1.6A1.612,1.612,0,0,1,7.016,15.706Zm4.457-1.066H17.4a.518.518,0,1,0,0-1.036H11.473a.518.518,0,0,0,0,1.036Z",
  transform: "translate(-4.419 -4.707)",
  fill: "currentColor"
});

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.502 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.93af1c1b.svg";
export { ForwardRef as ReactComponent };